/**
 * Shared star/date filter + stores-performance table defaults
 * used by group, manager, and individual performance screens.
 */
export const PERFORMANCE_FILTER_DEFAULT_MIN_STAR = ["0"];
export const PERFORMANCE_FILTER_DEFAULT_MAX_STAR = ["5"];
export const PERFORMANCE_FILTER_INITIAL_MAX_STAR = ["5.0"];
export const PERFORMANCE_FILTER_SELECT_MAX_MENU_HEIGHT = 200;
export const PERFORMANCE_FILTER_DAY_OFFSET = 1;

export const PERFORMANCE_DEFAULT_SORTING = {
  id: "name",
  desc: true,
};

export const PERFORMANCE_EXPORT_CSV_DELAY_MS = 1000;

export const PERFORMANCE_STATUS_LABELS = {
  TOTAL_CUSTOMERS: "Total Customers",
  TOTAL_RESPONSES: "Total Responses",
  TOTAL_STORES: "Total Stores",
  CONSUMER_RESPONSES: "Consumer Responses",
};

/** CSV headers for store-level performance exports (group / manager / individual group). */
export const storesPerformanceExportHeaders = [
  { label: "STORE NAME", key: "name" },
  { label: "TOTAL RESPONSES", key: "recordCount" },
  { label: "AVERAGE TRANSACTION RATING", key: "transactionRating" },
  { label: "PREVIOUS", key: "previousTransactionRating" },
  { label: "TRANSACTION CHANGE", key: "transactionChange" },
  { label: "AVERAGE SENTIMENT RATING", key: "sentimentRating" },
  { label: "PREVIOUS", key: "previousSentimentRating" },
  { label: "SENTIMENT CHANGE", key: "sentimentChange" },
];
